export default {
  namespaced: true,
  state: {
    virtual: {}
  },
  getters: {
    virtual(state) {
      return state.virtual
    }
  },
  mutations: {
    setVirtual(state, virtual) {
      state.virtual = virtual
    }
  },
  actions: {
    setVirtual({ commit }, data) {
      commit('setVirtual', data)
    }
  }
}
